// state.js

export default {
    portList: [],
};
